import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useState} from 'react';

import {mainState} from '../../AppMainState';
import Background from '../../assets/images/create_project_bg.png';
import {Button} from '../../components/Button';
import {Card} from '../../components/Card';
import {FormInput} from '../../components/form/FormInput';
import {CreateProjectState} from './CreateProjectState';


export const CreateProjectView: FC = observer(() => {
    const [state] = useState(() => new CreateProjectState());

    return <div
        style={{
            backgroundImage: `url(${Background})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        }}
        className="flex h-full items-center w-screen -mx-6 -my-5 p-6"
    >
        <div className="w-full max-w-lg sm:w-3/5">
            <h1 className="leading-tight mb-8 text-6xl">
                <span className="text-m-green">Create</span> <br />
                {mainState.projects?.length ?? -1 > 0 ? 'project' : 'your first project'}
            </h1>
            <Card>
                <form className="p-4" onSubmit={(e) => e.preventDefault()}>
                    <FormInput
                        id={'projectname'}
                        label={'Enter project name'}
                        name={'projectname'}
                        maxLength={20}
                        onChange={(e) => state?.setProjectName(e)}
                        value={state.name}
                    />
                    <Button className="btn btn-primary mt-6" onClick={() => state?.createProject()}>
                        Add new project
                    </Button>
                </form>
            </Card>
        </div>
    </div>;
});
